import * as Api from '../../../api/Api';
import { useEffect, useState, useContext } from 'react';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { useQuery } from 'react-query';
import { Loading } from '../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { registerLocale } from 'react-datepicker';
// import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import { Modal } from 'react-bootstrap-v5';
import * as KeyNames from '../../../api/KeyNames';
import * as Utilities from '../../../Components/Utils/Utils';
import { ErrorConnection } from "../../../Components/Error/Error";
import DatePicker from "react-date-picker"
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

export default function ActualizarContrato({ currentContrato, setSmShow }) {

    const token = useGetToken();

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let fechaIniTemp = currentContrato.fechaInicioOperaciones == "" ? null : new Date(Utilities.transformToDate(currentContrato.fechaInicioOperaciones));
    let fechaFinTemp = currentContrato.fechaFinOperaciones == "" ? null : new Date(Utilities.transformToDate(currentContrato.fechaFinOperaciones));
    const [startDate, setStartDate] = useState(fechaIniTemp)
    const [endDate, setEndDate] = useState(null)
    let startDateFormated = startDate == null ? null : Utilities.formaterDate(startDate);
    let endDateFormated = endDate == null ? null : Utilities.formaterDate(endDate);

    registerLocale('es', es);

    const [updateContrato, setUpdateContrato] = useState(false);


    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionRespuesta,
    {
        codContrato: currentContrato.codContrato,
        fechaInicioOperaciones: startDateFormated,
        fechaFinOperaciones: endDateFormated,
        token: token
    }],
        async () => await Api.ActualizarFechaContratos(
            {
                codContrato: currentContrato.codContrato,
                fechaInicioOperaciones: (startDateFormated) ? startDateFormated : '',
                fechaFinOperaciones: (endDateFormated) ? endDateFormated : '',
                token: token
            }
        ),
        {
            enabled: (Boolean(updateContrato))
        });


    useEffect(() => {
        if (data) {
            if (!data.success)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            else {
                setUpdateContrato(false);
                setSmShow(true);
            }
        }
    }, [data]);


    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error} />)

    return (
        <>
            <Modal show={true} onHide={() => setSmShow(false)} className=''>
                <Modal.Header className='modal-header'>
                    <Modal.Title className='fw-bolder'>Actualizar Contrato
                    </Modal.Title>
                    <button type="button" onClick={() => setSmShow(false)} className="btn btn-icon btn-sm btn-active-icon-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect>
                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect>
                        </svg>
                    </button>
                </Modal.Header>
                <Modal.Body className='modal-body mx-5 mx-xl-10 my-7'>

                    <div className="fv-row mb-7 fv-plugins-icon-container">
                        <label className='fw-bold fs-6 mb-2'>Denomicaión de Contrato</label>
                        <input className='form-control form-control-solid mb-3 mb-lg-0' type="text" defaultValue={currentContrato.denCont} disabled />

                    </div>
                    <div className="fv-row mb-7 fv-plugins-icon-container">
                        <label className='fw-bold fs-6 mb-2'>Código de contrato</label>
                        <input className='form-control form-control-solid mb-3 mb-lg-0' type="text" defaultValue={currentContrato.codContrato} disabled />

                    </div>

                    <div className="fv-row mb-7 fv-plugins-icon-container">
                        <label className='fw-bold fs-6 mb-2'>Rango de Fechas de Operaciones</label>
                        <div className='row'>
                            <div className='col-xs-12 col-sm-6'>
                                <div className='p-2'>
                                    <label className='fw-bold fs-6 mb-2'>Fecha de Inicio</label>
                                    <DatePicker
                                        className="form-control form-control-transparent pe-5"
                                        locale="es"
                                        value={startDate}
                                        onChange={(dateRange) => {
                                            setStartDate(dateRange);
                                        }}
                                        format="dd/MM/y"
                                    />
                                </div>
                            </div>
                            <div className='col-xs-12 col-sm-6'>
                                <div className='p-2'>
                                    <label className='fw-bold fs-6 mb-2'>Fecha Final</label>
                                    <DatePicker
                                        className="form-control form-control-transparent pe-5"
                                        locale="es"
                                        value={endDate}
                                        onChange={(dateRange) => {
                                            setEndDate(dateRange);
                                        }}
                                        format="dd/MM/y"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className='text-center'>
                    <button className="btn btn-light me-3" onClick={() => setSmShow(false)}>
                        Cerrar
                    </button>
                    <button className="btn btn-primary" onClick={() => { setUpdateContrato(true) }}>
                        Actualizar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}